import { isHomePage } from "../../utils/isHomePage";

function initHomeOurStory() {
  const observerOptions = {
    root: null,
    rootMargin: "50px",
    threshold: 0.1,
  };

  let isVideoLoaded = false;

  const loadVideo = () => {
    if (isVideoLoaded) return;

    const video = document.querySelector(".lazy-video");
    const placeholder = document.querySelector(".video-placeholder");

    if (video && video.dataset.src) {
      video.src = video.dataset.src;
      isVideoLoaded = true;

      video.addEventListener("loadeddata", () => {
        video.style.opacity = "1";
        if (placeholder) {
          placeholder.style.opacity = "0";
          setTimeout(() => {
            placeholder.remove();
          }, 300);
        }
      });
    }
  };

  const handleIntersection = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        loadVideo();
        observer.unobserve(entry.target);
      }
    });
  };

  const observer = new IntersectionObserver(
    handleIntersection,
    observerOptions
  );

  // Observe both elements
  const triggerElements = [
    document.querySelector(".double-unique-container"),
    document.querySelector(".lazy-video"),
  ];

  triggerElements.forEach((element) => {
    if (element) {
      observer.observe(element);
    }
  });
}

// Initialize on DOM load for initial content
document.addEventListener("DOMContentLoaded", initHomeOurStory);

// Initialize on dynamic content load if on homepage
if (isHomePage()) {
  document.addEventListener("bottomContentLoaded", initHomeOurStory);
}
